// extracted by mini-css-extract-plugin
export var falconContainer = "_uj-2";
export var offerCenter = "_uj-0";
export var roktContainer = "_uj-1";